import { render, staticRenderFns } from "./TaggingStrategyHeader.vue?vue&type=template&id=343143a9"
import script from "./TaggingStrategyHeader.vue?vue&type=script&lang=js"
export * from "./TaggingStrategyHeader.vue?vue&type=script&lang=js"
import style0 from "./TaggingStrategyHeader.vue?vue&type=style&index=0&id=343143a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports